import client from './client';

export async function getMemberList(params) {
  const res = await client.get('/admin/member', { params });
  return res.data;
}

export async function getMember(memberId) {
  const res = await client.get(`/admin/member/${memberId}`);
  return res.data;
}

export async function updateMember(memberId, payload) {
  const res = await client.put(`/admin/member/${memberId}`, payload);
  return res.data;
}

export async function withdrawMember(memberId, updatedBy) {
  const res = await client.put(`/admin/member/${memberId}/withdraw`, null, { params: { updatedBy } });
  return res.data;
}
